import {Inject, Injectable, Injector} from '@angular/core';
import {HttpHeaders, HttpResponse} from '@angular/common/http';
import {BaseService} from '../depends/base.service';
import { SessionStorageService } from 'ngx-webstorage/lib/services/sessionStorage';

@Injectable({
  providedIn: 'root'
})
export class NgxLoopDocumentService extends BaseService<any> {
  sessionStorage: SessionStorageService;
  enviroment;

  constructor(public injector: Injector,@Inject('environment') private env ) {
    super(injector, env,'core/document', (value) => {
      return value;
    });
    this.enviroment = env;
  }

  async getExternalDocument(type:string, resource_id:number|number[],customParams?:any) {

    let company = this.sessionStorage.retrieve('selectedCompany');

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    if(company){
      let id_company = company.id.toString();
      headers = headers.append('company',id_company);
    }

    let params = {};

    if(customParams != null)
      params = customParams;

    let url = this.enviroment.api + 'core/external/docs';

    return this.http.post(url,{type:type, id:resource_id}, {headers: headers, observe: 'response', params: params}).toPromise().then(
      (response: HttpResponse<any>) => {
        let data = response.body.data;
        return data;
      }
    ).catch(reason => {
      console.log(reason);
      throw reason;
    });
  }

  async getDocument(type:string, resource_id:number|number[],customParams?:any) {

    let dealer = this.sessionStorage.retrieve('dealer_group');

    let id_dealer_group = null;

    if (dealer) {
      id_dealer_group = dealer.id;
    }

    let header = await this.buildHeader();
    let params = BaseService.buildQueryParams({dealer_group: id_dealer_group});

    if(customParams != null)
      params = customParams;

    return this.http.post(this.apiPath,{type:type, id:resource_id}, {headers: header, observe: 'response', params: params}).toPromise().then(
      (response: HttpResponse<any>) => {
        let data = response.body.data;
        this.refreshToken(response.headers);
        return data;
      }
    ).catch(reason => {
      console.log(reason);
      this.willLogoutUser(reason);
      throw reason;
    });
  }

}
